import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import EventPage from './Component/Main/EventPage';
import CreateId from './Component/Main/CreateId';
import ArchiveEvent from './Component/Main/Archive/ArchiveEvent';
import BulkUploadForm from './Component/Main/BulkUploadForm';
import Approved from './Component/Main/Approved';
import Login from './Component/Auth/Login';
import PrivateRoute from './PrivateRoute';
import ArchiveIDCard from './Component/Main/Archive/ArchiveIDCard';
import EmbedForm from './Component/Main/EmbedFOrm/EmbedForm';
import Checkin from './Component/Main/Checkin';
import PublicCreateId from './Component/Main/PublicCreateId';
import LinkIDCard from './Component/Main/LinkIDCard';
import PublicRoute from './PublicRoute';
import MyIDCards from './Component/Main/MyIDCards';
import FullParticipantDetails from './Component/Main/components/FullParticipantDetails';
import { useUser } from './Component/Context/UserContext';
import ParticipantDetails from './Component/Main/components/ParticipantDetails';
import LandingPage from './Component/LandingPage/LandingPage';
import V2Routes from './v2/V2Routes';
import PublicRegistration from './pages/PublicRegistration';
import ParticipantPublicView from './pages/v2/ParticipantPublicView';
import ThankYouEvent from './pages/v2/ThankYouEvent';
import CustomEventRegistration from './pages/v2/CustomEventRegistration';
import CustomEventWorkshopRegistration from './pages/v2/CustomEventWorkshopRegistration';
import CustomEventPublicTicket from './pages/v2/CustomEventPublicTicket'; // Added
import CustomEventAbstractUndergrad from './pages/v2/CustomEventAbstractUndergrad';
import CustomEventAbstractMedical from './pages/v2/CustomEventAbstractMedical';
import CustomEventAbstractMain from './pages/v2/CustomEventAbstractMain'; // Added
import CustomEventAbstractAdmin from './pages/v2/CustomEventAbstractAdmin'; // Added
import CustomEventAdmin from './pages/v2/CustomEventAdmin'; // Added
import CustomEventAdminData from './pages/v2/CustomEventAdminData'; // Added
import CustomEventAdminApprove from './pages/v2/CustomEventAdminApprove'; // Added
import CustomEventAdminScan from './pages/v2/CustomEventAdminScan'; // Added
import ConferenceDashboard from './pages/v2/ConferenceDashboard';
import ConferenceIdCards from './pages/v2/ConferenceIdCards';
import EventScanPageV2 from './pages/v2/EventScanPageV2';
import ScanRedirectPage from './pages/v2/ScanRedirectPage';

const AppRoutes = () => {
  const { userDetails } = useUser();

  return (
    <Routes>
      {/* Login Page shown at root for non-authenticated users */}
      <Route path="/" element={<PublicRoute element={<Login />} />} />

      {/* Login Page */}
      <Route path="/login" element={<PublicRoute element={<Login />} />} />

      {/* Landing Page kept accessible at /landing */}
      <Route path="/landing" element={<PublicRoute element={<LandingPage />} />} />

      {/* Conditional routes based on eventId */}
      {(userDetails.eventId && userDetails.type == "user") ? (
        // User with eventId can only access /event
        <Route path="/create-id" element={<PrivateRoute element={CreateId} />} />

      ) : (
        // User without eventId can access all other routes
        <>
          <Route path="/event" element={<PrivateRoute element={EventPage} />} />
          <Route path="/create-id" element={<PrivateRoute element={CreateId} />} />
          <Route path="/bulk-create-id" element={<PrivateRoute element={BulkUploadForm} />} />
          <Route path="/archive-event" element={<PrivateRoute element={ArchiveEvent} />} />
          <Route path="/approve/:participantId" element={<PrivateRoute element={Approved} />} />
          <Route path="/checkin/:participantId" element={<PrivateRoute element={Checkin} />} />
          <Route path="/archive-id-card" element={<PrivateRoute element={ArchiveIDCard} />} />
          <Route path="/v2/events/*" element={localStorage.getItem('token') ? <V2Routes /> : <Navigate to="/" replace />} />
        </>
      )}

      {/* Public routes - accessible regardless of eventId */}
      <Route path="/form-url" element={<EmbedForm />} />
      <Route path="/register/:eventId" element={<PublicRegistration />} />
      <Route path="/public-create-id" element={<PublicCreateId />} />
      <Route path="/event/jss/conference" element={<CustomEventRegistration />} />
      <Route path="/event/jss/conference/participant/:regId" element={<CustomEventPublicTicket />} />
      <Route path="/event/jss/conference/admin" element={<CustomEventAdmin />} />

      <Route path="/event/jss/workshop" element={<CustomEventWorkshopRegistration />} />
      <Route path="/event/jss/workshop/participant/:regId" element={<CustomEventPublicTicket />} />

      <Route path="/event/jss/abstract/undergraduate-students" element={<CustomEventAbstractUndergrad />} />
      <Route path="/event/jss/abstract/completed-medical-undergraduate" element={<CustomEventAbstractMedical />} />

      {/* New Abstract Routes (Oral / Poster) */}
      <Route path="/event/jss/abstract/admin" element={<CustomEventAbstractAdmin />} />
      <Route path="/event/jss/abstract/:type/:role" element={<CustomEventAbstractMain />} />

      <Route path="/event/jss/admin/approve" element={<CustomEventAdminApprove />} />
      <Route path="/event/jss/admin/data" element={<CustomEventAdminData />} />
      <Route path="/event/jss/admin/scan" element={<CustomEventAdminScan />} />
      <Route path="/event/jss/admin/conference/dashboard" element={<ConferenceDashboard />} />
      <Route path="/event/jss/admin/conference/id-cards" element={<ConferenceIdCards />} />
      <Route path="/id-card/:eventId/:participantId" element={<LinkIDCard />} />
      <Route path="/my-id-cards" element={<MyIDCards />} />
      <Route path="/full-participant-details/event/:eventId" element={<ParticipantDetails />} />
      <Route path="/full-participant-details/:eventId" element={<FullParticipantDetails />} />
      <Route path="/event/:eventId/registration-success/:participantId" element={<ThankYouEvent />} />

      <Route path="/full-participant-details/:eventId/:tab" element={<FullParticipantDetails />} />

      {/* V2 Public Routes */}
      <Route path="/v2/participant/:id" element={<ParticipantPublicView />} />
      <Route path="/v2/scan/:participantId" element={<ScanRedirectPage />} />
      <Route path="/v2/checkin/:participantId" element={<EventScanPageV2 />} />

      {/* Catch all route - redirect users with eventId to /event */}
      <Route
        path="*"
        element={userDetails.eventId ? <Navigate to={`/create-id?eventid=${userDetails.eventId}&eventName=${userDetails.eventName || ''}`} replace /> : <Navigate to="/" replace />}
      />
    </Routes>
  );
};

export default AppRoutes;